// libraries
import { NavigationItemStatus } from '@makemydeal/dr-activities-shared';
import type { MakeOptional } from '@makemydeal/dr-shared-types';

// interfaces/types
import type { IFlowConfig } from '../../flowMasterInterfaces';

// consts/enums
import { APP_NAME } from './constants';

// middleware
import { customerCardMiddleware } from './middleware';
// The activity's own middleware (SPD lifecycle) — registered as its own chain entry in remainingMiddleware.
export { customerCardActivityMiddleware } from './middleware';

// config
export { configureMvCustomerCard } from './config';

// redux
import { customerCardReducer, customerSpdReducer } from '@makemydeal/dr-activities-customer-card';
// The activity owns a second reducer (SPD presence/PII state) registered under `activitiesCustomerSpd`.
export { customerSpdReducer as activitiesCustomerSpdReducer };

/**
 * Customer Card Activity Configuration.
 * Customer card is always rendered inside a slideout (EditCustomerSlideout),
 * not as a standalone routed activity. This config registers the middleware
 * and reducer only.
 */
export const customerCardConfiguration: MakeOptional<IFlowConfig<any>, 'routingComponent' | 'defaultRoute' | 'routes'> = {
    name: APP_NAME,
    navCard: {
        label: 'Customer Card',
        icon: 'person',
        cardId: 'dr-sp-customer-card'
    },
    showCardSelector: () => false,
    isCompleteSelector: () => false,
    reducer: customerCardReducer as any,
    middleware: customerCardMiddleware,
    isLocked: (_state: unknown) => false,
    dependsOnLeadFormCompletion: () => false,
    status: () => NavigationItemStatus.DEFAULT,
    isDisabled: () => false
};
